import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { QUERY_KEY } from '../../constants'
import type { components } from '../../constants/schema'

import { requestIdentify, convertIdentityVerificationResult } from '../../utils/identityVerification'

import { useUserInfo } from '../../hooks/useUserInfo'

import { getUnreadNotificationCount } from '../../api/notice'

import { Text } from '../../components/text'
import type { HeaderContentProps } from './Header'

import { ReactComponent as Logo } from '../../assets/logo/logo.svg'
import LogoBlack from '../../assets/logo/logo-black.png'
import { ReactComponent as Bell } from '../../assets/ico/common/notifications/notifications_default.svg'
import { ReactComponent as UnreadBell } from '../../assets/ico/common/notifications/notifications_unread.svg'
import { ReactComponent as BlackBell } from '../../assets/ico/common/notifications/notifications_default_black.svg'
import { ReactComponent as BlackUnreadBell } from '../../assets/ico/common/notifications/notifications_unread_black.svg'

export function Main({ isScrollEvent, isScrolling }: HeaderContentProps) {
  const location = useLocation()

  const { data: userInfo, isLoading } = useUserInfo()

  const { data: unreadNotificationCount } = useQuery({
    queryKey: [QUERY_KEY.unreadNotificationCount],
    queryFn: getUnreadNotificationCount,
  })

  const isScrolled = isScrollEvent && isScrolling

  useEffect(() => {
    if (!userInfo || localStorage.getItem('isVerification') !== 'true') return

    const identify = async (data: components['schemas']['ReqQueryIdentication']) => {
      if (!userInfo) return
      const response = await requestIdentify(data)
      if (!response) return
    }

    if (location.search.includes('identityVerificationId')) {
      const convertQuery = convertIdentityVerificationResult(location.search.substring(1))
      identify(convertQuery)
    }
  }, [location, userInfo])

  const BellIcon = () => {
    if (isScrolled) return unreadNotificationCount?.result ? <BlackUnreadBell /> : <BlackBell />
    return unreadNotificationCount?.result ? <UnreadBell /> : <Bell />
  }

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {isScrolled ? <img src={LogoBlack} alt="logo-black" style={{ width: '104px' }} /> : <Logo />}
      </div>
      <NotificationContainer>
        {!isLoading && !userInfo && (
          <Text size={16} weight={700} color={isScrolled ? 'text_primary' : 'text_white'}>
            <Link to="/signin">로그인</Link>
          </Text>
        )}
        <NotificationLink to="/notify">
          <BellIcon />
        </NotificationLink>
      </NotificationContainer>
    </>
  )
}

const NotificationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const NotificationLink = styled(Link)`
  height: 24px;
`
